const Wrapper = require('../Wrapper');

class PaginationWrapper extends  Wrapper {
    constructor(elementID) {
        super();

        this.element = document.getElementById(elementID);

        this.model = {
            page: 1
        };

        this.initEvents();
    }

    get value() {
        return this.model.page;
    }

    show() {
        window.$(this.element).show();
    }

    hide() {
        window.$(this.element).hide();
    }

    reset() {
        this.updateModel({ page: 1 }, false);
    }

    initEvents() {
        this.element.addEventListener('click', () => {
            this.updateModel( { page: this.model.page + 1 });
        });
    }
}

module.exports = PaginationWrapper;